import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import { useQuery } from "@tanstack/react-query";
import { Theme } from "../../../data/style/Theme";
import { getAthleteProfile } from "../../../api/user";
import { useAuth } from "../../../context/AuthContext";
import { SpacedRow, AllCenteredRow, MainText } from "../../../data/style/Style";

const WeeklyLeaderboardRow = ({ item, index }) => {
  const { user } = useAuth();

  const RowClass = {
    width: "90%",
    borderRadius: 3,
    padding: "7px 10px",
    border: "1px solid",
    borderColor:
      item.user === user.id ? "rgba(249,115,22,.28)" : Theme.palette.border,
    background:
      item.user === user.id ? "rgba(249,115,22,.06)" : Theme.palette.card,
    display: "flex",

    "&:hover": {
      borderColor: "rgba(249,115,22,.25)",
    },
  };

  const { data, isPending } = useQuery({
    queryKey: ["profile", item.user],
    queryFn: ({ signal }) => getAthleteProfile({ userId: item.user, signal }),
    retry: false,
    staleTime: 30 * 60 * 1000,
  });

  return (
    <>
      <Card elevation={5} sx={RowClass}>
        {!isPending && (
          <SpacedRow alignItems={"center"} width={"100%"} pr={1}>
            {index !== null && (
              <AllCenteredRow
                sx={{
                  background:
                    item.user === user.id
                      ? "rgba(249,115,22,.14)"
                      : Theme.palette.border,
                  borderRadius: 2,
                  padding: "5px 9px",
                  minWidth: "30px",
                }}
              >
                <MainText
                  fontWeight={"bold"}
                  sx={{
                    color:
                      item.user === user.id &&
                      Theme.palette.orange + " !important",
                  }}
                >
                  {20 - 2 * index}
                </MainText>
              </AllCenteredRow>
            )}
            <Avatar
              sx={{ width: 40, height: 40 }}
              alt={data.user_name}
              src={data.image}
            />
            <MainText
              sx={{
                color:
                  item.user === user.id && Theme.palette.orange + " !important",
              }}
            >
              {data.user_name}
            </MainText>
            <MainText
              fontWeight={700}
              sx={{
                color:
                  item.user === user.id && Theme.palette.orange + " !important",
              }}
            >
              {item.converted_score}
            </MainText>
          </SpacedRow>
        )}
      </Card>
    </>
  );
};

export default WeeklyLeaderboardRow;
